export enum ClientState {
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}